import { useAuth } from 'lib/auth';
import { useEffect, useState } from 'react';

const SUMO_SCRIPT_ID = 'sumo';
const SUMO_POPUP_SELECTOR = '.sumo-form-wrapper.listbuilder-popup';

let sumoInjected = false;

const SumoScript = ({ nonce }: { nonce?: string }) => {
  const { session, loading } = useAuth();
  const [pageLoaded, setPageLoaded] = useState(false);

  useEffect(() => {
    const onLoad = () => setPageLoaded(true);
    if (document.readyState === 'complete') setPageLoaded(true);
    else window.addEventListener('load', onLoad);
    return () => window.removeEventListener('load', onLoad);
  }, []);

  useEffect(() => {
    if (loading || !pageLoaded || session) return;
    if (sumoInjected) return;
    if (document.getElementById(SUMO_SCRIPT_ID)) {
      sumoInjected = true;
      return;
    }

    sumoInjected = true;

    const script = document.createElement('script');
    script.src = '/api/statics/sumo.js';
    script.async = true;
    script.id = SUMO_SCRIPT_ID;
    if (nonce) script.nonce = nonce;
    document.body.appendChild(script);
  }, [loading, session, pageLoaded, nonce]);

  useEffect(() => {
    if (session) return;

    const updateSumoPopup = () => {
      const popup = document.querySelector(
        SUMO_POPUP_SELECTOR,
      ) as HTMLElement | null;

      if (!popup) return;

      popup.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
    };

    updateSumoPopup();

    const observer = new MutationObserver(() => updateSumoPopup());

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [session]);

  useEffect(() => {
    if (!session) return;

    const disableSumo = () => {
      const w = window as any;

      ['sumo', 'sumome', '_sumo', '__smLoaded'].forEach((key) => {
        if (!w[key]) return;
        if (typeof w[key] === 'function') {
          w[key] = () => {};
        } else if (typeof w[key] === 'object') {
          Object.keys(w[key]).forEach((method) => {
            if (typeof w[key][method] === 'function') {
              try {
                w[key][method] = () => {};
              } catch (_) {
                // read-only property, skip
              }
            }
          });
        }
      });

      const selectors = [
        `#${SUMO_SCRIPT_ID}`,
        'script[src*="sumome.com"]',
        'script[src*="load.sumome.com"]',
        'script[src="//load.sumome.com/"]',
        'img[src*="sumome.com"]',
        '[id^="sumome"]',
        '[id^="sumo-"]',
        '[class*="sumome"]',
        '[class*="sumo-"]',
      ];
      selectors.forEach((selector) => {
        document
          .querySelectorAll(selector)
          .forEach((el) => el.remove());
      });

      document.querySelectorAll('style').forEach((style) => {
        if (
          style.innerHTML.includes('sumome') ||
          style.innerHTML.includes('sumo-')
        ) {
          style.remove();
        }
      });
    };

    disableSumo();

    const observer = new MutationObserver(() => disableSumo());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [session]);

  return null;
};

export default SumoScript;
